$(document).ready(() => {
    const $carousel = $('.carousel-container');

    $carousel.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        centerMode: false,
        customPaging: function (slider, index) {
            return '<button type="button" class="slick-dot">' + (index + 1) + '</button>';
        },
        prevArrow:
            '<button type="button" class="slick-prev" aria-disabled="true" aria-label="Previous slide"><svg width="20" height="20" viewBox="0 0 48 48"><path d="M0 0h48v48H0z" fill="none"/><g><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
        nextArrow:
            '<button type="button" class="slick-next" aria-disabled="false" aria-label="Next slide"><svg width="20" height="20" viewBox="0 0 48 48"><path d="M0 0h48v48H0z" fill="none"/><g><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
    });

    const updateArrows = (slick, currentSlide) => {
        $('.slick-prev').attr('disabled', currentSlide === 0).toggleClass('disabled', currentSlide === 0);
        $('.slick-next').attr('disabled', currentSlide === slick.slideCount - 1).toggleClass('disabled', currentSlide === slick.slideCount - 1);
    };

    $carousel.on('afterChange', (event, slick, currentSlide) => {
        updateArrows(slick, currentSlide);
    });

    // Wait for initial rendering
    setTimeout(() => {
        const slickObj = $carousel.slick('getSlick');
        updateArrows(slickObj, slickObj.currentSlide);
    }, 50);

    // Static star width set
    const starInner = document.querySelector('.reviews-carousel .star-inner');
    if (starInner) {
        starInner.style.width = `${(4.5 / 5) * 100}%`;
    }

    // Read more toggle
    function toggleReadMore(event) {
        event.preventDefault();
        const readMoreLink = event.target;
        const reviewContent = readMoreLink.closest('.review-content');
        const pElements = reviewContent.querySelectorAll('p');
        const secondP = pElements.length > 1 ? pElements[1] : null;

        if (secondP) {
            const isExpanded = readMoreLink.textContent === 'read less' || readMoreLink.textContent === 'weniger';
            secondP.style.webkitLineClamp = isExpanded ? '3' : 'unset';
            readMoreLink.textContent = isExpanded
                ? (readMoreLink.textContent === 'read less' ? 'read more' : 'mehr erfahren')
                : (readMoreLink.textContent === 'read more' ? 'read less' : 'weniger');
        }
    }

    function checkReadMore() {
        document.querySelectorAll('.review-content').forEach((reviewContent) => {
            const pElements = reviewContent.querySelectorAll('p');
            const secondP = pElements.length > 1 ? pElements[1] : null;
            const readMoreLink = reviewContent.querySelector('.read-more');

            if (secondP && readMoreLink) {
                const originalClamp = secondP.style.webkitLineClamp;
                const style = window.getComputedStyle(secondP);
                const lineHeight = parseFloat(style.lineHeight);
                const maxLines = 3;
                const maxHeight = lineHeight * maxLines;

                // Temporarily allow full height read
                secondP.style.webkitLineClamp = 'unset';
                const fullHeight = secondP.scrollHeight;
                secondP.style.webkitLineClamp = originalClamp || '3';

                readMoreLink.style.display = fullHeight <= maxHeight ? 'none' : '';
            }
        });
    }

    document.querySelectorAll('.review-content .read-more').forEach((readMoreLink) => {
        readMoreLink.addEventListener('click', toggleReadMore);
    });

    checkReadMore();
});
